import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { BidForecastAccuracyPage } from '@/components/Ams/bidSimulator/BidForecastAccuracyPage'
import {
  bidAccuracySearchSchema,
  pruneBidAccuracySearch,
} from '@/components/Ams/bidSimulator/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. Deliberately not in the menu, as in VentaHub: the simulator links here. */
export const Route = createFileRoute('/_app/marketing/ams/bid-accuracy/')({
  validateSearch: bidAccuracySearchSchema,
  component: BidAccuracyRoute,
})

function BidAccuracyRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <BidForecastAccuracyPage
      search={search}
      onSearchChange={(next) => void navigate(inPageSearch(pruneBidAccuracySearch, next))}
    />
  )
}
